module.exports = __webpack_public_path__ + "static/media/OTP_Verify_BG.0b2c8813.png";